export const DELIBERATION_LOADING = 'loading';
export const DELIBERATION_LOGIN = 'login';
export const DELIBERATION_LOGIN_RECEIPT = 'loginReceipt';
export const DELIBERATION_INVALID_PASSWORD = 'invalidPassword';
export const DELIBERATION_RECEIPT = 'receipt';
export const DELIBERATION_RESULT = 'result';
export const DELIBERATION_RESULT_COUNTING = 'resultCounting';
export const DELIBERATION_VOTING = 'voting';